import { useSearchParams } from "react-router-dom"
const useAccessManagementSearchParams = () => {
  const [searchParams] = useSearchParams()
  const params: AccessManagementSearchParamsType = {
    page: Number(searchParams.get("page")) || 1,
    quantity: Number(searchParams.get("quantity")) || 10,
    name: searchParams.get("name") || undefined,
    email: searchParams.get("email") || undefined,
    groups: searchParams.get("groups") || undefined,
    ownId: searchParams.get("ownId") || undefined,
    tab: searchParams.get("tab") || "team-access",
  }
  return {
    params,
  }
}
export default useAccessManagementSearchParams
